<h1>{{ productPlan | productName }}</h1>
<section>
	<text-group>
		<div>{{ 'invoice-details.period' | translate }}</div>
		<div class="align-right">{{ accountingPlan.startDate | customDate: 'shortDate' }} - {{ accountingPlan.endDate | customDate: 'shortDate' }}</div>
		<div>{{ 'invoice-details.payment-interval' | translate }}</div>
		<div class="align-right">{{ accountingPlan.paymentInterval | paymentInterval}}</div>
		<div>{{ 'invoice-details.reference-no' | translate }}</div>
		<div class="align-right">{{ accountingPlan.referenceNo }}</div>
	</text-group>
</section>
